// extracted by mini-css-extract-plugin
module.exports = {"title":"DataTitle_title__22cij","firstTitle":"DataTitle_firstTitle__2HSFX"};